var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#171717",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 2.40039C8.25097 2.40039 8.47548 2.55671 8.56261 2.79217L9.81732 6.18297L13.2081 7.43768C13.4436 7.52481 13.5999 7.74933 13.5999 8.00039C13.5999 8.25146 13.4436 8.47597 13.2081 8.5631L9.81732 9.81781L8.56261 13.2086C8.47548 13.4441 8.25097 13.6004 7.9999 13.6004C7.74884 13.6004 7.52432 13.4441 7.43719 13.2086L6.18248 9.81781L2.79168 8.5631C2.55622 8.47597 2.3999 8.25146 2.3999 8.00039C2.3999 7.74933 2.55622 7.52481 2.79168 7.43768L6.18248 6.18297L7.43719 2.79217C7.52432 2.55671 7.74884 2.40039 7.9999 2.40039ZM7.9999 4.72932L7.21216 6.85816C7.15139 7.02239 7.0219 7.15188 6.85767 7.21265L4.72883 8.00039L6.85767 8.78813C7.0219 8.8489 7.15139 8.97839 7.21216 9.14262L7.9999 11.2715L8.78764 9.14262C8.84842 8.97839 8.9779 8.8489 9.14213 8.78813L11.271 8.00039L9.14213 7.21265C8.9779 7.15188 8.84842 7.02239 8.78764 6.85816L7.9999 4.72932Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartStar);
export default __webpack_public_path__ + "static/media/smart-star.8d244bb26dda017404ce6e00ddbac9d3.svg";
export { ForwardRef as ReactComponent };